import { safeDefineElement } from '@/scripts/core/global'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { AnnouncementBar } from '@/scripts/theme/announcement-bar'
import { BeforeAfter } from '@/scripts/theme/before-after'
import { UgcSlider } from '@/scripts/theme/ugc-slider'
import { TestimonialsSlider } from '@/scripts/theme/testimonials-slider'
import { SquaresSlider } from '@/scripts/theme/squares-slider'
import { IngredientsSlider } from '@/scripts/theme/ingredients-slider'
import { ProductCard } from '@/scripts/theme/product-card'
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { BasicAccordion } from '@/scripts/theme/basic-accordion'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
safeDefineElement(DeferredMedia)
safeDefineElement(SliderComponent)
safeDefineElement(SlideshowComponent)
safeDefineElement(StickyHeader)
safeDefineElement(DetailsDisclosure)
safeDefineElement(AnnouncementBar)
safeDefineElement(BeforeAfter)
safeDefineElement(UgcSlider)
safeDefineElement(TestimonialsSlider)
safeDefineElement(SquaresSlider)
safeDefineElement(IngredientsSlider)
safeDefineElement(ProductCard)
safeDefineElement(ProductSlider)
safeDefineElement(MultiProductSlider)
safeDefineElement(BasicAccordion)
safeDefineElement(KlaviyoForm)
safeDefineElement(WelcomePopup)
safeDefineElement(WaitlistForm)
